import { Reveal, Stagger, staggerItem } from "../components/Reveal";
import { motion } from "framer-motion";
import { PROBLEMS } from "../data/content";

export default function Problema() {
  return (
    <section id="problema" data-testid="problema-section" className="py-24 md:py-36 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl">
          <p className="overline mb-6">
            <span className="text-[#D7C6A3]">02</span> &nbsp;/&nbsp; El problema
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            ¿Te ha pasado alguna vez…?
          </h2>
        </Reveal>

        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {PROBLEMS.map(({ text, Icon }, i) => (
            <motion.div
              key={i}
              variants={staggerItem}
              data-testid={`problem-${i}`}
              className="bg-white border border-[#EBEBEB] rounded-3xl p-8 hover:-translate-y-1 transition-transform duration-500"
            >
              <div className="w-12 h-12 rounded-full bg-[#F6F1E7] flex items-center justify-center mb-6">
                <Icon size={24} weight="light" className="text-[#8A9A6F]" />
              </div>
              <p className="text-[#4A554E] leading-relaxed">{text}</p>
            </motion.div>
          ))}
          <motion.div
            variants={staggerItem}
            className="bg-[#A3B18A] rounded-3xl p-8 flex items-center"
          >
            <p className="font-display text-3xl text-white leading-tight">
              Con VITAE todo tiene su lugar.
            </p>
          </motion.div>
        </Stagger>
      </div>
    </section>
  );
}
